import { gql } from '@apollo/client';

export const BATCH_IS_AUTO_ROUTE_GRAY = gql`
    query BatchIsAutoRouteGray($warehouseId: Long!, $areaIds: [Long!]!) {
        batchIsAutoRouteGray(warehouseId: $warehouseId, areaIds: $areaIds) {
            areaId
            gray
        }
    }
`;

export interface AutoRouteGrayResult {
    areaId: number;
    gray: boolean;
}

export interface BatchIsAutoRouteGrayResponse {
    batchIsAutoRouteGray: AutoRouteGrayResult[];
}

export interface BatchIsAutoRouteGrayVariables {
    warehouseId: number;
    areaIds: number[];
}